var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomDomainBranding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1707 1707",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_614997080"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1471 1707h-1234c-70 0-126-57-126-127v-1454c0-70 56-126 126-126h1232c70 0 127 56 127 126v1454c2 70-55 127-125 127z",
    fill: "#d6dde6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1471 1660c45 0 78-36 78-80v-1454c0-44-36-79-80-79h-1232c-44 0-79 35-79 79v1454c0 44 35 80 79 80z",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041 204h-62c-20 0-35-15-35-33 0-17 15-35 35-35h62c20 0 35 16 35 35 0 20-15 33-35 33z",
    fill: "#e26693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1232 204h-62c-20 0-35-15-35-33 0-17 15-35 35-35h62c19 0 35 16 35 35 0 20-18 33-35 33z",
    fill: "#ffaf10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1421 204h-63c-19 0-35-15-35-33 0-17 16-35 35-35h63c19 0 35 16 35 35 0 20-16 33-35 33z",
    fill: "#37c47a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111 126v144 69h660 825v-69-144c0-70-57-126-127-126h-877-83-272c-70 0-126 56-126 126zm676 144-195-270 195 270h809zm383-134h62c19 0 35 16 35 35 0 20-18 33-35 33h-62c-20 0-35-15-35-33 0-17 15-35 35-35zm188 68c-19 0-35-15-35-33 0-17 16-35 35-35h63c19 0 35 16 35 35 0 20-16 33-35 33zm-414-33c0-17 15-35 35-35h62c20 0 35 16 35 35 0 20-15 33-35 33h-62c-20 0-35-15-35-33z",
    fill: "#293d7c"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m853 1231c-208 0-377-169-377-377s169-378 377-378 378 170 378 378-170 377-378 377z",
    fill: "#49a7fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 1231c-112 0-199-167-199-377 0-213 87-378 199-378 113 0 201 167 201 378 0 212-88 377-201 377zm0-706c-73 0-151 132-151 329s78 328 151 328c84 0 153-151 153-328 0-179-69-329-153-329z",
    fill: "#4296e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 1055c-212 0-377-89-377-201 0-113 167-200 377-200 211 0 378 87 378 200 0 112-165 201-378 201zm0-353c-197 0-328 78-328 152 0 83 151 152 328 152 178 0 329-69 329-152 0-74-132-152-329-152z",
    fill: "#4296e5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d6dde6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m526 1277h-250c-14 0-25-11-25-25s11-25 25-25h250c14 0 25 11 25 25s-11 25-25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1430 1277h-249c-14 0-25-11-25-25s11-25 25-25h249c14 0 25 11 25 25s-11 25-25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1279 1418h-851c-14 0-25-11-25-25s11-25 25-25h853c13 0 24 11 24 25s-12 25-26 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1415 1569h-1123c-14 0-25-11-25-25 0-13 11-25 25-25h1123c14 0 25 12 25 25 0 14-11 25-25 25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDomainBranding);
export default __webpack_public_path__ + "static/media/custom-domain-branding.9a64917bf60b0f99454ac9792d6b5d2a.svg";
export { ForwardRef as ReactComponent };